// TermsAndConditionsPage.jsx
import React from 'react';
import './LeaderBoard.css'; // CSS for styling this page

const TermsAndConditionsPage = () => {
  return (
    <div className="terms-conditions-container">
      <div className="terms-conditions-content">
        <h1>Terms and Conditions for Opt-In to Wanna Practice Leaderboard</h1>

        <p>
          Welcome to the Wanna Practice Leaderboard! Before you opt-in to participate,
          please carefully read these Terms and Conditions. By opting in, you agree
          to be bound by the following:
        </p>

        <h2>1. Consent to Use Personal Information</h2>
        <p>
          By opting in, you explicitly consent to Wanna Practice using the name you
          provide at the time of opt-in and your full test score for the purpose
          of displaying and comparing performance on the Leaderboard.
        </p>

        <h2>2. Purpose of Data Usage</h2>
        <p>
          The information collected (your name and test score) will be used solely
          for ranking and comparing users who participate in the same Certification
          tests within the Wanna Practice platform.
        </p>

        <h2>3. Display on Leaderboard</h2>
        <p>
          Your name and test score will be visible to other users on the leaderboard
          to promote healthy competition and performance transparency.
        </p>

        <h2>4. Data Accuracy</h2>
        <p>
          You are responsible for providing accurate information during the opt-in
          process. Incorrect or misleading information may affect your leaderboard
          ranking and participation.
        </p>

        <h2>5. Privacy and Security</h2>
        <p>
          Wanna Practice is committed to protecting your personal information. Your
          data will be handled in accordance with our Privacy Policy{' '}
          <a href="/privacy-policy" target="_blank" rel="noopener noreferrer">
             privacy policy page
          </a>
          . We will not use your information for any purposes other than those
          explicitly stated here without your additional consent.
        </p>

        <h2>6. Opt-Out</h2>
        <p>
          You may withdraw your consent and opt-out of the leaderboard at any time
          by clicking on toggle button. Upon opting out, your information will be
          removed from the leaderboard within a reasonable timeframe.
        </p>

        <h2>7. No Guarantee of Ranking</h2>
        <p>
          Participation in the leaderboard does not guarantee any ranking or reward.
          Rankings are based solely on the scores achieved in the certification
          tests.
        </p>

        <h2>8. Changes to Terms</h2>
        <p>
          Wanna Practice reserves the right to modify these Terms and Conditions at
          any time. Users will be notified of any changes, and continued
          participation in the leaderboard constitutes acceptance of the updated
          terms.
        </p>

        <h2>9. Contact Us</h2>
        <p>
          If you have any questions about these Terms and Conditions, please contact
          us at:{' '}
          {/* Replace with your actual support email */}
          <a href="mailto:support@example.com">support@wannapractice.com</a>
        </p>

        <p className="agreement-statement">
          By opting in, you acknowledge that you have read, understood, and agree
          to these Terms and Conditions.
        </p>
      </div>
    </div>
  );
};

export default TermsAndConditionsPage;